/* NH sort control: chips (wide) + bottom sheet (phone). Plain GET navigation keeps ?sort_by in the URL and the back button native. */
(() => {
  if (window.__nhSort) return;
  window.__nhSort = true;
  const html = document.documentElement;

  const init = (root) => {
    if (root.hasAttribute('data-ready')) return;
    const sheet = root.querySelector('[data-nhsort-sheet]');
    const opener = root.querySelector('[data-nhsort-open]');
    const out = root.querySelector('[data-nhsort-current]');
    const key = root.querySelector('.nhsort__trigger-k');
    const initial = root.dataset.current || '';
    const canModal = !!(sheet && typeof sheet.showModal === 'function');
    if (canModal) root.setAttribute('data-ready', '');

    const close = () => { if (sheet && sheet.open) sheet.close(); };

    const apply = (form, input) => {
      if (!input) return;
      if (input.value === initial) { close(); return; }
      if (out) out.textContent = input.dataset.label || '';
      if (key) key.textContent = 'Sort:';
      root.setAttribute('aria-busy', 'true');
      html.classList.add('nhsort-loading');
      close();
      form.submit();
    };

    root.querySelectorAll('[data-nhsort-form]').forEach((form) => {
      let viaArrow = false;
      form.addEventListener('keydown', (e) => {
        const t = e.target;
        if (!(t instanceof HTMLInputElement) || t.name !== 'sort_by') return;
        if (e.key.startsWith('Arrow')) { viaArrow = true; return; }
        if (e.key === 'Enter' || (e.key === ' ' && t.checked)) { e.preventDefault(); apply(form, t); }
      });
      /* Pointer / VoiceOver double-tap / Space: apply at once. Arrow keys only move the selection (WCAG 3.2.2); Enter applies. */
      form.addEventListener('change', (e) => {
        const t = e.target;
        if (!(t instanceof HTMLInputElement) || t.name !== 'sort_by') return;
        if (viaArrow) { viaArrow = false; return; }
        apply(form, t);
      });
      /* Tapping the option that is already active just closes the sheet. */
      form.addEventListener('click', (e) => {
        const t = e.target;
        if (t instanceof HTMLInputElement && t.name === 'sort_by' && !viaArrow && t.value === initial) close();
      });
    });

    if (!canModal) return;
    opener.addEventListener('click', () => {
      sheet.showModal();
      opener.setAttribute('aria-expanded', 'true');
      html.classList.add('nhsort-lock');
      (sheet.querySelector('.nhsort__input:checked') || sheet.querySelector('.nhsort__input'))?.focus();
    });
    sheet.addEventListener('close', () => {
      opener.setAttribute('aria-expanded', 'false');
      html.classList.remove('nhsort-lock');
      if (!root.hasAttribute('aria-busy')) opener.focus();
    });
    sheet.querySelector('[data-nhsort-close]')?.addEventListener('click', close);
    /* Tap on the backdrop (the dialog box itself, outside its content) closes. */
    sheet.addEventListener('click', (e) => { if (e.target === sheet) close(); });

    /* Returning via the back button (bfcache): restore the real state. */
    window.addEventListener('pageshow', (e) => {
      if (!e.persisted) return;
      root.removeAttribute('aria-busy');
      html.classList.remove('nhsort-loading', 'nhsort-lock');
      close();
      root.querySelectorAll('.nhsort__input').forEach((i) => { i.checked = i.value === initial; });
      const cur = root.querySelector('.nhsort__input:checked');
      if (out) out.textContent = cur ? cur.dataset.label || '' : '';
      if (key) key.textContent = cur ? 'Sort:' : 'Sort';
    });
  };

  /* Filter drawer quick price chips: set the From/To range and apply at once; tapping the active chip clears it. */
  document.addEventListener('click', (e) => {
    const chip = e.target instanceof Element && e.target.closest('[data-nhp-pchip]');
    if (!chip) return;
    const form = chip.closest('form');
    const box = chip.closest('details') || form;
    const [gte, lte] = [box.querySelector('input[name$="price.gte"]'), box.querySelector('input[name$="price.lte"]')];
    if (!form || !gte || !lte) return;
    const on = chip.getAttribute('aria-pressed') === 'true';
    /* Clamp to the inputs' own max so native validation never blocks the submit. */
    const cap = Number(lte.max) || Infinity;
    const max = Number(chip.dataset.max);
    gte.value = on ? '' : chip.dataset.min;
    lte.value = on || !chip.dataset.max || max >= cap ? '' : chip.dataset.max;
    box.querySelectorAll('[data-nhp-pchip]').forEach((c) => c.setAttribute('aria-pressed', String(c === chip && !on)));
    chip.setAttribute('aria-busy', 'true');
    if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit();
  });

  /* Brand facet (snippets/nh-brand-filter): popular chips proxy the A–Z checkboxes; search filters both lists; A–Z jumps inside the drawer. */
  const brandBox = (el) => el.closest('[data-nhp-brands]');
  document.addEventListener('click', (e) => {
    const t = e.target instanceof Element ? e.target : null;
    const pick = t && t.closest('[data-nhp-bpick]');
    if (pick) {
      const box = brandBox(pick);
      const input = [...box.querySelectorAll('.nhp-brands__all input[type="checkbox"]')].find((i) => i.value === pick.dataset.nhpBpick);
      if (input) {
        input.checked = !input.checked;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }
    const jump = t && t.closest('[data-nhp-az]');
    if (jump) {
      const box = brandBox(jump);
      const head = box.querySelector(`[data-nhp-azl="${CSS.escape(jump.dataset.nhpAz)}"]`);
      if (!head) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      head.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' });
      head.nextElementSibling?.querySelector('input')?.focus({ preventScroll: true });
    }
  });
  document.addEventListener('change', (e) => {
    const t = e.target;
    if (!(t instanceof HTMLInputElement) || t.type !== 'checkbox') return;
    const box = brandBox(t);
    if (!box) return;
    box.querySelectorAll('[data-nhp-bpick]').forEach((b) => {
      if (b.dataset.nhpBpick === t.value) b.setAttribute('aria-pressed', String(t.checked));
    });
  });
  let bTimer = 0;
  document.addEventListener('input', (e) => {
    const t = e.target;
    if (!(t instanceof HTMLInputElement) || !t.matches('[data-nhp-bsearch]')) return;
    cancelAnimationFrame(bTimer);
    bTimer = requestAnimationFrame(() => {
      const box = brandBox(t);
      if (!box.__nhp) {
        box.__nhp = {
          rows: [...box.querySelectorAll('.nhp-brands__all .nhp-check')],
          heads: [...box.querySelectorAll('[data-nhp-azl]')],
          chips: [...box.querySelectorAll('[data-nhp-bpick]')],
          pop: box.querySelector('[data-nhp-bpop]'),
          az: box.querySelector('[data-nhp-azrow]'),
          none: box.querySelector('[data-nhp-bnone]'),
        };
      }
      const c = box.__nhp;
      const q = t.value.trim().toLowerCase();
      const seen = new Set();
      let shown = 0;
      for (const r of c.rows) {
        const on = !q || r.dataset.label.includes(q);
        r.hidden = !on;
        if (on) { shown += 1; seen.add(r.dataset.letter); }
      }
      for (const h of c.heads) h.hidden = !seen.has(h.dataset.nhpAzl);
      let chipsOn = 0;
      for (const b of c.chips) { const on = !q || b.dataset.label.includes(q); b.hidden = !on; if (on) chipsOn += 1; }
      if (c.pop) c.pop.hidden = chipsOn === 0;
      if (c.az) c.az.hidden = !!q;
      if (c.none) { c.none.hidden = shown > 0; c.none.textContent = shown ? '' : `No brands match "${t.value.trim()}"`; }
    });
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && e.target instanceof HTMLInputElement && e.target.matches('[data-nhp-bsearch]')) e.preventDefault();
  });

  const boot = () => document.querySelectorAll('[data-nhsort]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
